import { ArrowBack, NotificationsRounded } from '@mui/icons-material';
import { Badge, LinearProgress } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useSettings from '../../hooks/useSettings';
import { appName } from '../../utils/config';
import ThemeToggleButton from '../utilities/ThemeToggleButton';

export default function KanisaHeader({
    title,
    tab,
    authPass,
    controls,
    disableBackButton,
    backAction,
    themeToggle,
    loading,
}) {
    // const theme = useTheme();
    const navigate = useNavigate();
    const state = useSelector((st) => st);
    const { themeMode } = useSettings();

    const { announcements } = state.list2;
    const { reminders } = state.list2;
    const badgeCount = announcements?.length + reminders?.length;
    const badgeCountMinus = localStorage.getItem('knsappntf');
    const notificationCount = badgeCount - badgeCountMinus;

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <AppBar className={classes.appbar} elevation={4} position="fixed">
                <Toolbar className={classes.toolbar}>
                    {!backAction && !tab && !disableBackButton && (
                        <IconButton
                            color={
                                themeMode === 'light' ? 'primary' : 'inherit'
                            }
                            edge="start"
                            className={classes.menuButton}
                            aria-label="menu"
                            onClick={() => navigate(-1)}
                        >
                            <ArrowBack />
                        </IconButton>
                    )}
                    {backAction}
                    <Typography
                        variant="h5"
                        noWrap={true}
                        className={classes.title}
                    >
                        {title ? title : appName}
                    </Typography>
                    {(themeToggle ||
                        state.auth.user?.contact?.phoneNumber ==
                            '799055101') && (
                        <ThemeToggleButton color="primary" />
                    )}
                    {!controls && !authPass && (
                        <>
                            <IconButton
                                onClick={() => navigate('/notifications')}
                                color="primary"
                            >
                                <Badge
                                    badgeContent={
                                        notificationCount > 0
                                            ? notificationCount
                                            : 0
                                    }
                                    color="secondary"
                                >
                                    <NotificationsRounded />
                                </Badge>
                            </IconButton>
                        </>
                    )}
                    {controls}
                </Toolbar>
                {loading && <LinearProgress className="w-100" />}
            </AppBar>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        margin: 'auto',
    },
    menuButton: {
        marginRight: theme.spacing(1),
        border: 'none',
    },
    title: {
        flexGrow: 1,
        color:
            theme.palette.mode === 'light'
                ? theme.palette.primary.main
                : '#fff',
    },
    toolbar: {
        boxShadow: 'none',
        backgroundColor: theme.palette.background.default,
    },
    appbar: {
        margin: 'auto',
        backgroundColor: theme.palette.mode === 'light' && '#fff',
    },
}));
